import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {ListScreen, Select} from '../components';
import {
    fetchPoints,
    cleanPoints,
    setUser,
    changeUserSetting,
    deletePoint,
} from '../actions';
import {__, formatDate, toNumber} from '../functions';
import { COURIERS, COUNTRIES } from '../config';
import '../assets/styles/points.css';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from "@mui/icons-material/AddCircle";

/**
 * Points.
 */
class PointsScreen extends ListScreen {
    title = __('Mapy');

    state = { ...ListScreen.state, ...{
        lightbox: {
            delete: false,
            create: false,
        },
    }};

    memoryCache = {};

    isValidPermission() {
        return this.hasPermission('points');
    }

    getTableName() {
        return 'points';
    }

    getColumns() {
        return [
            <div>{__('Prepravca')}</div>,
            <div>{__('Krajina')}</div>,
            <div>{__('Doména')}</div>,
            <div>{__('Typ dodania')}</div>,
            <div>{__('Vytvorené')}</div>,
            <div></div>,
        ];
    }

    getCells(item) {
        const { items } = this.props;

        return [
            <div>{_.has(items.user_couriers, item.courier_id)
                ? (_.has(COURIERS, items.user_couriers[item.courier_id].name) ? COURIERS[items.user_couriers[item.courier_id].name] : items.user_couriers[item.courier_id].name)
                : item.courier_id}</div>,
            <div>{_.has(COUNTRIES, item.country) ? COUNTRIES[item.country] : item.country}</div>,
            <div>{item.settings.url}</div>,
            <div>{item.settings.delivery_name}</div>,
            <div>{formatDate(item.created, 'dd.mm.yyyy')}</div>,
            <div>
                {this.hasPermission('points-edit') ? this.renderTableButton(
                    item.id,
                    __('Upraviť'),
                    <EditIcon />,
                    (callbackLoading, callback) => this.redirect(`/maps/view/${item.id}/${item.user_courier_id}`),
                    {}
                ) : null}
                {this.hasPermission('points-delete') ? this.renderTableButton(
                    item.id,
                    __('Zmazať'),
                    <DeleteIcon />,
                    (callbackLoading, callback) => this.confirmDelete(item.id, callbackLoading, callback),
                    {}
                ) : null}
            </div>,
        ];
    }

    getTags() {
        const { user, items } = this.props;

        if (toNumber(user.user_eshop_id) === 0) {
            return [
                {
                    name: __('Nemáte aktívne prepojenie na eshop.'),
                    color: 'orange',
                }
            ];
        }

        if (_.isEmpty(items.user_couriers)) {
            return [
                {
                    name: __('Nemáte aktívne prepojenie na prepravcu ktorý poskytuje výdajné miesta.'),
                    color: 'orange',
                }
            ];
        }

        if (!this.hasPermission('points-create')) {
            return [];
        }

        const user_couriers = _.reduce(items.user_couriers, (result, item) => ({ ...result, [item.id]: (_.has(COURIERS, item.name) ? COURIERS[item.name] : item.name) }), {});

        return [
            {
                name: __('Nová mapa'),
                onClick: () => this.showLightbox('create', {
                    data: {
                        user_courier_id: _.keys(user_couriers)[0],
                    },
                    user_couriers,
                }),
                color: 'secondary',
                icon: <AddIcon />,
                disabled: this.isDemo(),
            }
        ];
    }

    getEmptyText() {
        return __('Zatiaľ nemáte žiadne mapy');
    }

    onChangeCreate(key, value) {
        const { lightbox } = this.state;

        this.setState({ lightbox: { ...lightbox, create: {
            ...lightbox.create,
            data: { ...lightbox.create.data, [key]: value }
        } } });
    }

    onChangeCreateLoading(value) {
        const { lightbox } = this.state;

        this.setState({ lightbox: { ...lightbox, create: { ...lightbox.create, loading: value } } })
    }

    create() {
        const { lightbox } = this.state;

        this.redirect(`/maps/view/0/${lightbox.create.data.user_courier_id}`);
    }

    confirmDelete(id, callbackLoading, callback) {
        this.showLightbox('delete', { id, callbackLoading, callback });
    }

    async delete() {
        const { deletePoint, items } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            // Zavrieme lightbox
            this.closeLightbox('delete');

            this.showSnackbar('error', __('Mapu nie je možné zmazať na DEMO účte'));
            return;
        }

        // Zavolame loading
        lightbox.delete.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('delete');

        // Zmazeme
        await deletePoint(this, lightbox.delete.id);

        // Zavolame callback
        lightbox.delete.callback();

        // Znovu nacitame zoznam od prvej stranky
        this.fetchList(1, 0, items.filtered);
    }

    renderScreen() {
        const { lightbox } = this.state;

        return (
            <div>
                {this.renderLightbox(
                    'delete',
                    __('Naozaj chcete zmazať túto mapu?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.delete()
                )}
                {this.renderLightbox(
                    'create',
                    __('Nová mapa'),
                    !_.isEmpty(lightbox.create) ? <div>
                        <Select
                            options={lightbox.create.user_couriers}
                            value={lightbox.create.data.user_courier_id}
                            onChange={value => this.onChangeCreate('user_courier_id', value)}
                            allowEmpty={false}
                        />
                    </div> : null,
                    __('Uložiť'),
                    __('Zrušiť'),
                    () => this.create()
                )}
            </div>
        );
    }
}

const stateToProps = ({ points, user }) => ({ items: points, user });

export default withCookies(connect(stateToProps, {
    fetch: fetchPoints,
    clean: cleanPoints,
    setUser,
    changeUserSetting,
    deletePoint,
})(PointsScreen));
